import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type ErrorStateProps = {
	onRefetch: () => void;
	description: string;
	testId?: string;
};
const ErrorState = ({ onRefetch, description, testId }: ErrorStateProps) => {
	const { formatMessage } = useIntl();
	return (
		<EmptyStateContainer data-testId={testId}>
			<EmptyState
				header={description}
				primaryAction={
					<Button
						onClick={onRefetch}
						appearance="primary"
						testId="software-code-page.common.ui.error-state.button"
					>
						{formatMessage(messages.refreshCta)}
					</Button>
				}
				renderImage={() => (
					<WarningIcon
						label={description}
						primaryColor={token('color.background.warning.bold', colors.Y400)}
					/>
				)}
			/>
		</EmptyStateContainer>
	);
};

export default ErrorState;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EmptyStateContainer = styled.div({
	margin: `${token('space.negative.300', '-24px')} 0`,
});
